module.exports = __webpack_public_path__ + "img/factory-swiper-4.6e88bff4.png";